import { ZdsIconButton } from '@zera/components'
import { motion } from 'framer-motion'
import styled from 'styled-components'

export const Container = styled(motion.div)`
  position: relative;
  width: 100%;

  border-bottom: 2px solid #dce0e8;
  background: #edeff3;
  transform-origin: top;
  overflow: hidden;

  svg {
    flex-shrink: 0;
  }
`

export const Title = styled.h3`
  color: #000000;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
`

export const Description = styled.p`
  font-family: 'Inter';
  color: #484b52;
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
`

export const CloseButton = styled(ZdsIconButton).attrs(props => ({
  ...props,
  src: 'MiClose',
  color: '#000',
  dataTestId: 'hat-alert-close-button'
}))`
  padding: 0;

  &:hover {
    opacity: 0.8;
  }
`
